import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';

/**
 * Public landing page after MSAL logout. Portals that wire `/sign-out` as postLogoutRedirectUri
 * land here instead of bouncing the user straight back into a guarded route (and another login).
 */
@Component({
  imports: [MatButtonModule],
  selector: 'lib-sign-out',
  styleUrl: './sign-out.component.scss',
  templateUrl: './sign-out.component.html'
})
export class SignOutComponent {
  private readonly router: Router = inject(Router);

  public signIn(): void {
    void this.router.navigateByUrl('/');
  }
}
